import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  CircularProgress,
  Divider,
  IconButton,
  Grid,
  useTheme,
  Chip,
  IconButton as MuiIconButton,
} from "@mui/material";
import { Close, Add, Delete } from "@mui/icons-material";
import { url } from "../constants/url";
import CustomAlert from "../components/customAlert";
import { useThemeToggle } from "../context/ThemeContext";

const AddLead = ({ userData, onClose, onSuccess }) => {
  const theme = useTheme();
  const { mode } = useThemeToggle();
  const UID = userData?._id;
  const role = userData?.role;

  const [companies, setCompanies] = useState([]);
  const [companyId, setCompanyId] = useState("");
  const [companyData, setCompanyData] = useState([]);

  const [formData, setFormData] = useState({
    clientName: "",
    contactNo: "",
    email: "",
    leadSources: [], // Changed to array of selected sources
    servicesInterested: [], // Changed to array of selected services
  });

  const [currentSource, setCurrentSource] = useState({
    source: "",
    otherSource: "",
  });
  const [currentService, setCurrentService] = useState({
    service: "",
    otherService: "",
  });

  const [loading, setLoading] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");

  // Fetch companies
  useEffect(() => {
    const fetchCompanies = async () => {
      if (role === "teamMember") {
        try {
          const res = await fetch(
            `${url}/api/company/fetch-company-assigned-to?userId=${UID}`
          );
          const data = await res.json();
          setCompanies(data?.data || []);
        } catch (error) {
          showAlert("error", "❌ Error fetching companies");
        }
      } else if (role === "admin") {
        if (userData?.companyAdded?.length > 0) {
          setCompanyId(userData.companyAdded[0].companyId);

          const response = await fetch(
            `${url}/api/company/fetch-company-by-id?companyId=${userData.companyAdded[0].companyId}`
          );

          const data = await response.json();
          setCompanyData(data?.data || []);
        }
      }
    };
    fetchCompanies();
  }, [UID, role, userData]);

  // Add lead source
  const addSource = () => {
    if (!currentSource.source.trim()) {
      showAlert("error", "Please select a lead source.");
      return;
    }

    const sourceValue =
      currentSource.source === "Other"
        ? currentSource.otherSource
        : currentSource.source;

    if (!sourceValue.trim()) {
      showAlert("error", "Please specify the source.");
      return;
    }

    // Check if source already exists
    if (formData.leadSources.some((source) => source.source === sourceValue)) {
      showAlert("error", "This source has already been added.");
      return;
    }

    const newSource = {
      source: sourceValue,
      originalSource: currentSource.source,
      otherSource:
        currentSource.source === "Other" ? currentSource.otherSource : null,
    };

    setFormData({
      ...formData,
      leadSources: [...formData.leadSources, newSource],
    });

    // Reset current source
    setCurrentSource({ source: "", otherSource: "" });
  };

  // Remove lead source
  const removeSource = (index) => {
    const updatedSources = formData.leadSources.filter((_, i) => i !== index);
    setFormData({ ...formData, leadSources: updatedSources });
  };

  // Add service
  const addService = () => {
    if (!currentService.service.trim()) {
      showAlert("error", "Please select a service.");
      return;
    }

    const serviceValue =
      currentService.service === "Other"
        ? currentService.otherService
        : currentService.service;

    if (!serviceValue.trim()) {
      showAlert("error", "Please specify the service.");
      return;
    }

    // Check if service already exists
    if (
      formData.servicesInterested.some(
        (service) => service.service === serviceValue
      )
    ) {
      showAlert("error", "This service has already been added.");
      return;
    }

    const newService = {
      service: serviceValue,
      originalService: currentService.service,
      otherService:
        currentService.service === "Other" ? currentService.otherService : null,
    };

    setFormData({
      ...formData,
      servicesInterested: [...formData.servicesInterested, newService],
    });

    // Reset current service
    setCurrentService({ service: "", otherService: "" });
  };

  // Remove service
  const removeService = (index) => {
    const updatedServices = formData.servicesInterested.filter(
      (_, i) => i !== index
    );
    setFormData({ ...formData, servicesInterested: updatedServices });
  };

  const handleCompanyChange = (e) => {
    setCompanyId(e.target.value);
  };

  const showAlert = (severity, message) => {
    setAlertSeverity(severity);
    setAlertMessage(message);
    setAlertOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (!companyId) {
  //     showAlert("error", "Please select a company.");
  //     return;
  //   }

  //   // Validate sources
  //   if (formData.leadSources.length === 0) {
  //     showAlert("error", "Please add at least one lead source.");
  //     return;
  //   }

  //   // Validate services
  //   if (formData.servicesInterested.length === 0) {
  //     showAlert("error", "Please add at least one service.");
  //     return;
  //   }

  //   const phoneWithCode = `+91${formData.contactNo}`;
  //   setLoading(true);

  //   try {
  //     // Prepare services data
  //     const servicesData = formData.servicesInterested.map((service) => ({
  //       service: service.service,
  //       otherService:
  //         service.originalService === "Other" ? service.otherService : null,
  //       price: 0,
  //       quantity: 1,
  //       description: "",
  //     }));

  //     // Prepare lead sources data
  //     const leadSourcesData = formData.leadSources.map((source) => ({
  //       source: source.source,
  //       otherSource:
  //         source.originalSource === "Other" ? source.otherSource : null,
  //       details: "",
  //     }));

  //     console.log("📤 Sending lead data:", {
  //       services: servicesData,
  //       sources: leadSourcesData,
  //     });

  //     const response = await fetch(`${url}/api/leads/add-lead`, {
  //       method: "POST",
  //       headers: { "Content-Type": "application/json" },
  //       body: JSON.stringify({
  //         userId: UID,
  //         companyId,
  //         clientName: formData.clientName,
  //         contactNo: phoneWithCode,
  //         email: formData.email,
  //         leadSources: leadSourcesData,
  //         servicesInterested: servicesData,
  //       }),
  //     });

  //     const data = await response.json();

  //     if (response.ok) {
  //       showAlert("success", "Lead added successfully!");
  //       setFormData({
  //         clientName: "",
  //         contactNo: "",
  //         email: "",
  //         leadSources: [],
  //         servicesInterested: [],
  //       });

  //       if (onSuccess) {
  //         onSuccess();
  //       }

  //       setTimeout(() => {
  //         if (onClose) onClose();
  //       }, 800);
  //     } else {
  //       showAlert("error", data.message || "Error adding lead");
  //     }
  //   } catch (error) {
  //     console.error("❌ Error adding lead:", error);
  //     showAlert("error", "Error adding lead");
  //   }

  //   setLoading(false);
  // };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!companyId) {
    showAlert("error", "Please select a company.");
    return;
  }

  // Validate sources
  if (formData.leadSources.length === 0) {
    showAlert("error", "Please add at least one lead source.");
    return;
  }

  // Validate services
  if (formData.servicesInterested.length === 0) {
    showAlert("error", "Please add at least one service.");
    return;
  }

  const phoneWithCode = `+91${formData.contactNo}`;
  setLoading(true);

  try {
    // Prepare services data
    const servicesData = formData.servicesInterested.map((service) => ({
      service: service.service,
      otherService:
        service.originalService === "Other" ? service.otherService : null,
      price: 0,
      quantity: 1,
      description: "",
    }));

    // Prepare lead sources data
    const leadSourcesData = formData.leadSources.map((source) => ({
      source: source.source,
      otherSource:
        source.originalSource === "Other" ? source.otherSource : null,
      details: "",
    }));

    console.log("📤 Sending lead data:", {
      services: servicesData,
      sources: leadSourcesData,
    });

    const response = await fetch(`${url}/api/leads/add-lead`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        userId: UID,
        companyId,
        clientName: formData.clientName,
        contactNo: phoneWithCode,
        email: formData.email,
        leadSources: leadSourcesData,
        servicesInterested: servicesData,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      showAlert("success", "Lead added successfully!");
      setFormData({
        clientName: "",
        contactNo: "",
        email: "",
        leadSources: [],
        servicesInterested: [],
      });

      if (onSuccess) {
        onSuccess();
      }

      setTimeout(() => {
        if (onClose) onClose();
      }, 800);
    } else {
      // 🚨 HANDLE DUPLICATE ERROR
      if (response.status === 409) {
        // Check if it's a phone or email duplicate
        if (data.message.includes("phone number")) {
          showAlert("error", `Phone number already exists! ${data.existingLead?.clientName} (${data.existingLead?.contactNo})`);
        } else if (data.message.includes("email")) {
          showAlert("error", `Email already exists! ${data.existingLead?.clientName} (${data.existingLead?.email})`);
        } else {
          showAlert("error", data.message || "Duplicate entry found");
        }
      } else {
        showAlert("error", data.message || "Error adding lead");
      }
    }
  } catch (error) {
    console.error("❌ Error adding lead:", error);
    showAlert("error", "Network error - please try again");
  }

  setLoading(false);
};
  const handleClose = () => {
    if (onClose) onClose();
  };

  return (
    <>
      <Box sx={{ width: "750px", maxWidth: "100%", mx: "auto" }}>
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: "0 4px 16px rgba(0,0,0,0.08)",
            p: 2,
            position: "relative",
            backgroundColor:
              mode === "dark" ? theme.palette.background.paper : "white",
          }}
        >
          {onClose && (
            <IconButton
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 12,
                top: 12,
                color:
                  mode === "dark"
                    ? theme.palette.text.primary
                    : "text.secondary",
                "&:hover": {
                  backgroundColor:
                    mode === "dark"
                      ? theme.palette.action.hover
                      : "rgba(0,0,0,0.04)",
                },
              }}
            >
              <Close />
            </IconButton>
          )}

          <CardContent>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                mb: 1,
                textAlign: "center",
                pr: onClose ? 4 : 0,
                color: mode === "dark" ? theme.palette.text.primary : "inherit",
              }}
            >
              Add New Lead
            </Typography>

            <Divider
              sx={{
                my: 2,
                borderColor:
                  mode === "dark"
                    ? theme.palette.grey[700]
                    : "rgba(0,0,0,0.12)",
              }}
            />

            <form onSubmit={handleSubmit}>
              {/* Basic Information */}
              <Grid container spacing={3} alignItems="center">
                {/* Company Name */}
                {role === "admin" && userData?.companyAdded?.length > 0 && (
                  <Grid item xs={12} md={6} display="flex">
                    <TextField
                      fullWidth
                      label="Company"
                      value={companyData?.name || ""}
                      InputProps={{ readOnly: true }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          backgroundColor:
                            mode === "dark"
                              ? theme.palette.background.default
                              : "#f5f5f5",
                          color:
                            mode === "dark"
                              ? theme.palette.text.primary
                              : "inherit",
                        },
                        "& .MuiInputLabel-root": {
                          color:
                            mode === "dark"
                              ? theme.palette.text.secondary
                              : "inherit",
                        },
                        width: "330px",
                      }}
                    />
                  </Grid>
                )}

                {/* Team Member Company Selection */}
                {role === "teamMember" && (
                  <Grid item xs={12} md={6} display="flex">
                    <FormControl fullWidth required>
                      <InputLabel
                        sx={{
                          color:
                            mode === "dark"
                              ? theme.palette.text.secondary
                              : "inherit",
                        }}
                      >
                        Select Company
                      </InputLabel>
                      <Select
                        value={companyId}
                        onChange={handleCompanyChange}
                        label="Select Company"
                        sx={{
                          backgroundColor:
                            mode === "dark"
                              ? theme.palette.background.default
                              : "#f5f5f5",
                          color:
                            mode === "dark"
                              ? theme.palette.text.primary
                              : "inherit",
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor:
                              mode === "dark"
                                ? theme.palette.grey[600]
                                : "#bdbdbd",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: theme.palette.primary.main,
                          },
                          "& .MuiSelect-icon": {
                            color:
                              mode === "dark"
                                ? theme.palette.text.secondary
                                : "inherit",
                          },
                          width: "330px",
                        }}
                      >
                        {companies.map((c) => (
                          <MenuItem
                            key={c._id}
                            value={c._id}
                            sx={{
                              backgroundColor:
                                mode === "dark"
                                  ? theme.palette.background.paper
                                  : "white",
                              "&:hover": {
                                backgroundColor:
                                  mode === "dark"
                                    ? theme.palette.action.hover
                                    : theme.palette.action.hover,
                              },
                            }}
                          >
                            {c.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}

                {/* Client Name */}
                <Grid item xs={12} md={6} display="flex">
                  <TextField
                    fullWidth
                    label="Client Name"
                    name="clientName"
                    value={formData.clientName}
                    onChange={(e) =>
                      setFormData({ ...formData, clientName: e.target.value })
                    }
                    required
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          mode === "dark"
                            ? theme.palette.background.default
                            : "#f5f5f5",
                        color:
                          mode === "dark"
                            ? theme.palette.text.primary
                            : "inherit",
                      },
                      "& .MuiInputLabel-root": {
                        color:
                          mode === "dark"
                            ? theme.palette.text.secondary
                            : "inherit",
                      },
                      width: "330px",
                    }}
                  />
                </Grid>

                {/* Email */}
                <Grid item xs={12} md={6} display="flex">
                  <TextField
                    fullWidth
                    label="Client Email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          mode === "dark"
                            ? theme.palette.background.default
                            : "#f5f5f5",
                        color:
                          mode === "dark"
                            ? theme.palette.text.primary
                            : "inherit",
                      },
                      "& .MuiInputLabel-root": {
                        color:
                          mode === "dark"
                            ? theme.palette.text.secondary
                            : "inherit",
                      },
                      width: "330px",
                    }}
                  />
                </Grid>

                {/* Contact Number */}
                <Grid item xs={12} md={6} display="flex">
                  <TextField
                    fullWidth
                    label="Contact Number"
                    name="contactNo"
                    value={formData.contactNo}
                    onChange={(e) => {
                      const digits = e.target.value
                        .replace(/\D/g, "")
                        .slice(-10);
                      setFormData({ ...formData, contactNo: digits });
                    }}
                    required
                    InputProps={{
                      startAdornment: (
                        <Typography
                          sx={{
                            mr: 1,
                            color:
                              mode === "dark"
                                ? theme.palette.text.primary
                                : "inherit",
                          }}
                        >
                          +91
                        </Typography>
                      ),
                    }}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor:
                          mode === "dark"
                            ? theme.palette.background.default
                            : "#f5f5f5",
                        color:
                          mode === "dark"
                            ? theme.palette.text.primary
                            : "inherit",
                      },
                      "& .MuiInputLabel-root": {
                        color:
                          mode === "dark"
                            ? theme.palette.text.secondary
                            : "inherit",
                      },
                      width: "330px",
                    }}
                  />
                </Grid>
              </Grid>

              {/* Lead Sources Section */}
              <Box sx={{ mt: 3 }}>
                <Typography
                  variant="h6"
                  sx={{
                    mb: 2,
                    color:
                      mode === "dark" ? theme.palette.text.primary : "inherit",
                  }}
                >
                  Lead Sources
                </Typography>

                {/* Selected Sources as Chips */}
                {formData.leadSources.length > 0 && (
                  <Box sx={{ mb: 2 }}>
                    {formData.leadSources.map((source, index) => (
                      <Chip
                        key={index}
                        label={source.source}
                        onDelete={() => removeSource(index)}
                        color="primary"
                        variant="outlined"
                        sx={{ m: 0.5 }}
                      />
                    ))}
                  </Box>
                )}

                {/* Add Source Form */}
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "flex-start",
                    flexWrap: "wrap",
                  }}
                >
                  <FormControl sx={{ minWidth: 200 }}>
                    <InputLabel>Lead Source</InputLabel>
                    <Select
                      value={currentSource.source}
                      onChange={(e) =>
                        setCurrentSource({
                          ...currentSource,
                          source: e.target.value,
                        })
                      }
                      label="Lead Source"
                      sx={{
                        backgroundColor:
                          mode === "dark"
                            ? theme.palette.background.default
                            : "#f5f5f5",
                      }}
                    >
                      <MenuItem value="CEO">CEO</MenuItem>
                      <MenuItem value="SocialMedia">Social Media</MenuItem>
                      <MenuItem value="Referral">Referral</MenuItem>
                      <MenuItem value="Website">Website</MenuItem>
                      <MenuItem value="ColdCalling">Cold Calling</MenuItem>
                      <MenuItem value="EmailMarketing">
                        Email Marketing
                      </MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>

                  {currentSource.source === "Other" && (
                    <TextField
                      label="Specify Source"
                      value={currentSource.otherSource}
                      onChange={(e) =>
                        setCurrentSource({
                          ...currentSource,
                          otherSource: e.target.value,
                        })
                      }
                      sx={{ minWidth: 200 }}
                    />
                  )}

                  <Button
                    startIcon={<Add />}
                    onClick={addSource}
                    variant="outlined"
                    sx={{ height: "56px" }}
                  >
                    Add Source
                  </Button>
                </Box>
              </Box>

              {/* Services Interested Section */}
              <Box sx={{ mt: 3 }}>
                <Typography
                  variant="h6"
                  sx={{
                    mb: 2,
                    color:
                      mode === "dark" ? theme.palette.text.primary : "inherit",
                  }}
                >
                  Services Interested
                </Typography>

                {/* Selected Services as Chips */}
                {formData.servicesInterested.length > 0 && (
                  <Box sx={{ mb: 2 }}>
                    {formData.servicesInterested.map((service, index) => (
                      <Chip
                        key={index}
                        label={service.service}
                        onDelete={() => removeService(index)}
                        color="secondary"
                        variant="outlined"
                        sx={{ m: 0.5 }}
                      />
                    ))}
                  </Box>
                )}

                {/* Add Service Form */}
                <Box
                  sx={{
                    display: "flex",
                    gap: 2,
                    alignItems: "flex-start",
                    flexWrap: "wrap",
                  }}
                >
                  <FormControl sx={{ minWidth: 200 }}>
                    <InputLabel>Service Interested</InputLabel>
                    <Select
                      value={currentService.service}
                      onChange={(e) =>
                        setCurrentService({
                          ...currentService,
                          service: e.target.value,
                        })
                      }
                      label="Service Interested"
                      sx={{
                        backgroundColor:
                          mode === "dark"
                            ? theme.palette.background.default
                            : "#f5f5f5",
                      }}
                    >
                      <MenuItem value="Lead Generation">
                        Lead Generation
                      </MenuItem>
                      <MenuItem value="Podcast">Podcast</MenuItem>
                      <MenuItem value="Social Media Management">
                        Social Media Management
                      </MenuItem>
                      <MenuItem value="Content Marketing">
                        Content Marketing
                      </MenuItem>
                      <MenuItem value="SEO">SEO</MenuItem>
                      <MenuItem value="Web Development">
                        Web Development
                      </MenuItem>
                      <MenuItem value="Other">Other</MenuItem>
                    </Select>
                  </FormControl>

                  {currentService.service === "Other" && (
                    <TextField
                      label="Specify Service"
                      value={currentService.otherService}
                      onChange={(e) =>
                        setCurrentService({
                          ...currentService,
                          otherService: e.target.value,
                        })
                      }
                      sx={{ minWidth: 200 }}
                    />
                  )}

                  <Button
                    startIcon={<Add />}
                    onClick={addService}
                    variant="outlined"
                    sx={{ height: "56px" }}
                  >
                    Add Service
                  </Button>
                </Box>
              </Box>

              {/* Action Buttons */}
              <Box sx={{ mt: 3, display: "flex", gap: 2 }}>
                {onClose && (
                  <Button
                    onClick={handleClose}
                    variant="outlined"
                    fullWidth
                    sx={{
                      py: 1.3,
                      fontSize: "1rem",
                      fontWeight: 600,
                      borderRadius: 2,
                      borderColor: theme.palette.error.main,
                      color: theme.palette.error.main,
                      "&:hover": {
                        borderColor: theme.palette.error.dark,
                        backgroundColor: theme.palette.action.hover,
                      },
                    }}
                    disabled={loading}
                  >
                    Cancel
                  </Button>
                )}
                <Button
                  type="submit"
                  variant="contained"
                  fullWidth
                  sx={{
                    py: 1.3,
                    fontSize: "1rem",
                    fontWeight: 600,
                    borderRadius: 2,
                    background: theme.palette.success.main,
                    "&:hover": {
                      background: theme.palette.success.dark,
                    },
                  }}
                  disabled={loading}
                  startIcon={loading && <CircularProgress size={20} />}
                >
                  {loading ? "Submitting..." : "Submit Lead"}
                </Button>
              </Box>
            </form>
          </CardContent>
        </Card>
      </Box>

      {/* Custom Alert */}
      <CustomAlert
        open={alertOpen}
        severity={alertSeverity}
        message={alertMessage}
        onClose={handleAlertClose}
      />
    </>
  );
};

export default AddLead;
